import React from 'react';
import classNames from 'classnames';
import { makeStyles, Paper } from '@material-ui/core';
import BalanceSheetChart from 'Components/UI/Snapshot/BalanceSheetChart';
import BalanceSheet from 'Components/UI/Snapshot/BalanceSheet';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2),
    flex: '1 1',
    gap: `${theme.spacing(2)}px`,
  },
  [theme.breakpoints.down('md')]: {
    root: {
      flexDirection: 'column',
    },
  },
  chartContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    minHeight: theme.dimensions.lg,
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
}));

export default function BalanceSheetContainer({ className, elevation }) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <Paper elevation={elevation} className={classes.tableContainer}>
        <BalanceSheet />
      </Paper>
      <Paper elevation={elevation} className={classes.chartContainer}>
        <BalanceSheetChart />
      </Paper>
    </div>
  );
}

BalanceSheetContainer.defaultProps = {
  className: '',
  elevation: 2,
};

BalanceSheetContainer.propTypes = {
  className: PropTypes.string,
  elevation: PropTypes.number,
};
